// extracted by mini-css-extract-plugin
module.exports =  {"root":"Sfp08AJZv6eHmCP9ERaR","dragOverlay":"IzefVcCWkfuQirER56fv"};